import {io, Socket} from 'socket.io-client';
import {env} from '@src/config';

export let socket: Socket | null = null;

export const socketInitializer = (token: string) => {
  if (isSocketConnected()) {
    socket?.disconnect();
  }
  socket = io(env.NEXT_PUBLIC_WEBSOCKET, {
    extraHeaders: {authorization: token},
  });
  return socket;
};
export interface sendMessageRequest {
  otherSideUserId: string;
  textMessage: string;
}
export const sendMessage = (body: sendMessageRequest) => {
  if (socket) {
    console.log('[chat] emit sendMessage', {
      event: 'sendMessage',
      body,
      socketConnected: socket.connected,
      socketId: socket.id,
    });
    const res = socket.emit('sendMessage', body);
    console.log('[chat] sendMessage emit result connected=', res.connected);
  } else {
    console.warn('[chat] sendMessage skipped — socket is null', body);
  }
};
export interface sendMessageWithAttachmentRequest {
  messageId: string;
}
export const sendMessageWithAttachment = (
  body: sendMessageWithAttachmentRequest
) => {
  if (socket) {
    console.log('[chat] emit sendMessageWithAttachment', {
      event: 'sendMessageWithAttachment',
      body,
      socketConnected: socket.connected,
      socketId: socket.id,
    });
    const res = socket.emit('sendMessageWithAttachment', body);
    console.log(
      '[chat] sendMessageWithAttachment emit result connected=',
      res.connected
    );
  } else {
    console.warn(
      '[chat] sendMessageWithAttachment skipped — socket is null',
      body
    );
  }
};
export const isSocketConnected = () => {
  if (!socket) {
    return false;
  }
  return !socket.disconnected;
};
export function getSocket(token: string) {
  if (!socket) {
    return socketInitializer(token);
  }
  return socket;
}
export const removeSocket = () => {
  socket?.close();
  socket = null;
};
